import React from 'react';

import formatPrice from 'Shared/util/formatPrice';
import formatDate from 'Shared/util/formatDate';
import TableInvoiceDetail from './TableInvoiceDetail';

const RightPart = ({ data }) => {
  const { lines, total, currency, payments, subject, contactEmail } = data;

  return (
    <div className="tab-invoice-detail__right-part">
      <div className="tab-invoice-detail__paper tab-invoice-detail__table">
        <TableInvoiceDetail invoiceLines={lines} currency={currency} />
      </div>
      <div className="tab-invoice-detail__paper subject_block">
        {total && (
          <div className="total_block">
            <div className="total_block__label">Total amount</div>
            <div className="bank_account total_block__price">
              {formatPrice(total)} {currency}
            </div>
          </div>
        )}
        {subject && (
          <>
            <div className="subject_block__label">Subject</div>
            <div className="subject_block__title">{subject}</div>
            <div className="question_block">
              <div className="question_block__label">
                Any questions? Please let us know{' '}
                <a href={`mailto:${contactEmail}`} className="question_block__link">
                  {contactEmail}
                </a>
              </div>
            </div>
          </>
        )}
      </div>
      {payments && payments.length > 0 && (
        <div className="tab-invoice-detail__paper payment-block">
          <div className="paper-container">
            <div>
              <span className="paper-title">Received payments</span>
            </div>
          </div>
          {payments.map((item) => (
            <div key={item.id} className="paper-container">
              <div className="paper-container__row">
                <div className="payments_date">{formatDate(item.createdAt)}</div>
                <div className="payments_amount">
                  {formatPrice(item.amount)} {currency}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default RightPart;
